export const lamapiPath = '/lamapi/public';
export const slimPath = '/php';
export const nodePath = '/jsajax';
